import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import PublicNav from "../components/PublicNav";
import SalesChatWidget from "../components/SalesChatWidget";

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    document.title = "Handyman Certification Guides | Platinum 1 Certified";
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-950" data-testid="blog-page">
      <PublicNav />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-24">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-orange-600">Guides &amp; Insights</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mt-3 max-w-3xl">
          Build a handyman business homeowners trust.
        </h1>
        <p className="text-slate-600 mt-4 max-w-2xl text-base md:text-lg">
          Trade know-how, certification tips, and the business side of being a pro.
        </p>

        {posts === null && <div className="mt-12 text-slate-500">Loading…</div>}
        {posts && posts.length === 0 && (
          <div className="mt-12 border border-dashed border-slate-300 rounded-sm p-10 text-slate-500" data-testid="blog-empty">
            New articles are on the way. Check back soon.
          </div>
        )}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-8">
          {posts?.map((p, i) => (
            <Link
              key={p.post_id}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className={`${i === 0 ? "md:col-span-8" : "md:col-span-4"} group bg-white border border-slate-200 rounded-sm p-8 hover:-translate-y-1 hover:shadow-md transition-all duration-200 flex flex-col`}
            >
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">{p.published_at?.slice(0, 10)}</div>
              <h2 className={`font-display font-bold tracking-tight mt-3 ${i === 0 ? "text-2xl md:text-3xl" : "text-xl"}`}>{p.title}</h2>
              <p className="text-slate-600 mt-3 flex-1">{p.excerpt}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-orange-600 font-semibold text-sm">
                Read article <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </section>
      <SalesChatWidget />
    </div>
  );
}
